import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { PedidoBonificacaoTotal } from '../bonificacao';
import { PedidoNotaFiscal } from '../nota-fiscal';
import { PedidoFilho } from '../filho';

@Injectable({
    providedIn: 'root'
})
export class PedidoSearchesHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/pedido`;
    }

    /** Pesquisa todas as notas fiscais do pedido informado */
    searchNotasFiscais(idPedido: number): Observable<PedidoNotaFiscal[]> {
        return this.customHttp.get<PedidoNotaFiscal[]>(`${this.pathApi}/${idPedido}/notafiscal`);
    }

    /** Pesquisa todos os pedidos filhos do pedido informado */
    searchPedidosFilhos(idPedido: number): Observable<PedidoFilho[]> {
        return this.customHttp.get<PedidoFilho[]>(`${this.pathApi}/${idPedido}/filho`);
    }

    /** Pesquisa os totais das bonificações de pedidos */
    searchBonificacoesTotais(idsPeriodos: number[], idsRepresentantes: number[], idsAtendentes: number[]): Observable<PedidoBonificacaoTotal> {
        // Params
        let params = new HttpParams();
        // Períodos
        if (idsPeriodos && idsPeriodos.length > 0) {
            idsPeriodos.forEach(id => {
                params = params.append('idPeriodo', id.toString());
            });
        }
        // Representantes
        if (idsRepresentantes && idsRepresentantes.length > 0) {
            idsRepresentantes.forEach(id => {
                params = params.append('idRepresentante', id.toString());
            });
        }
        // Atendentes
        if (idsAtendentes && idsAtendentes.length > 0) {
            idsAtendentes.forEach(id => {
                params = params.append('idAtendente', id.toString());
            });
        }

        return this.customHttp.get<PedidoBonificacaoTotal>(`${this.pathApi}/0/bonificacoes/total`, {params});
    }
}
